export const emptyGuid = '00000000-0000-0000-0000-000000000000'

//Determine if a guid is empty
export function isEmptyGuid(guid)
{
	return guid == '' || !guid || guid == emptyGuid || guid.toLowerCase() == 'undefined' || guid == undefined;
}